export const typeList_common = [
    1 /** 随路数据 */, 3 /** 预处理数据 */, 6 /** 业务记录 */, 15 /** 工单信息 */,
];
